<div class="title">Presets<button *ngIf="selectedType !== ''" type="button" class="rounded btn btn-sm btn-primary"
    (click)="Add()">
    <span class="fas fa-plus"></span>
  </button></div>
<div class="workspace">
  <div class=" form-group type-sel-section">
    <label>Define presets for:</label>
    <select [(ngModel)]="selectedType" class="form-select">
      <option value="">Select a preset type</option>
      <option value="point">Points</option>
      <option value="segment">Segments</option>
    </select>
  </div>
  <div class="app-row full-width">
    <div #pointPresets class="listing list-points app-row" [class.hidden]="!showingPoints">
      <div *ngFor="let ptPreset of ptPresets" class="form-group-horizontal full-width app-row">
        <div class="form-label-inline full-width" [innerText]="ptPreset.label"></div>
        <div class="form-group-horizontal fitted no-gap">
          <button (click)="Select(ptPreset)" type="button" class="btn row-btn btn-sm btn-primary"><span class="fas fa-cog"></span></button>
          <button type="button" class="btn btn-danger row-btn btn-sm"><span class="fas fa-times"></span></button>
        </div>
      </div>
    </div>
    <div #segmentAtts class="listing list-segments" [class.hidden]="!showingSegments">
      <div *ngFor="let segPreset of segmentPresets"  class="form-group-horizontal full-width app-row">
        <div class="form-label-inline full-width" [innerText]="segPreset.label"></div>
        <div class="form-group-horizontal fitted no-gap">
          <button (click)="Select(segPreset)" type="button" class="btn row-btn btn-sm btn-primary"><span class="fas fa-cog"></span></button>
          <button type="button" class="btn btn-danger row-btn btn-sm"><span class="fas fa-times"></span></button>
        </div>
      </div>
    </div>
  </div>
</div>
